const TabSwitcher = (tabSelector, tabBtnSelector, contentSelector) => {
  const tab = document.querySelector(tabSelector);
  const tabBtn = document.querySelectorAll(tabBtnSelector);
  const content = document.querySelectorAll(contentSelector);

  tab.onclick = (evt) => {
    const id = evt.target.dataset.id;
    if (id) {
      tabBtn.forEach((btn) => {
        btn.classList.remove('active-href');
      });
      evt.target.classList.add('active-href');

      content.forEach((content) => {
        content.classList.remove('active-tab');
      });
      const element = document.getElementById(id);
      element.classList.add('active-tab');
    }
  };
};

export default TabSwitcher;
